import React from 'react'
import { withStyles, Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { useDispatch } from 'react-redux'
import styles from './styles'
import data from './constants'
import { DynamicAttributes } from './components'
import { componentBoxShowAction } from 'src/reducers/component-box/action'
import ComponentBoxContent from 'src/model/component-box'
import { patchCollectionLandingPageAction } from 'src/reducers/collection/action'
import { CoreButton } from 'src/components/core'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'
import ContainerMediaGalery from 'src/container/image-gallery'

const Highlights = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const { id, subPage } = useParams()
  const history = useHistory()

  const handleButtonClick = index => {
    if (index === data.length - 1) {
      // Open media gallery for logo
      dispatch(
        messageBoxShowAction(
          MessageBoxContent({
            type: MessageBoxType.WARNING,
            buttons: [],
            title: `
              <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                <Icon icon="ic:round-add-a-photo" color="#00AB55" width="24" height="24" />
                <Typography style="margin-left: 8; color: #002E47; fontWeight: 600; fontSize: 16;">
                  Media Gallery - Logo
                </Typography>
              </div>
            `,
            component: (
              <ContainerMediaGalery
                onOk={items => {
                  if (landingPageData) {
                    dispatch(
                      patchCollectionLandingPageAction(collection.id, [
                        {
                          path: 'logo',
                          value: items[0].url,
                        },
                      ]),
                    )
                  }
                  dispatch(messageBoxHideAction('message-box-1'))
                }}
                setImageURL={() => {}}
              />
            ),
            variant: MessageBoxVariant.DRAGGABLE,
            maxHeight: '640px',
          }),
        ),
      )
    } else if (index === 0) {
      dispatch(
        componentBoxShowAction(
          new ComponentBoxContent(<DynamicAttributes />, {
            hideCloseButton: true,
            callback: e => {},
          }),
        ),
      )
    } else if (index === 1) {
      // find subPage in pathname and replace it with 'learner-access'
      const newPath = window.location.pathname.replace(
        subPage,
        'learner-authentication',
      )
      history.push(newPath)
    }
  }

  const landingPageData = useSelector(
    state => state.collection.landingPageSettings,
  )
  const collection = useSelector(state => state.collection.collection)

  return (
    <div className={classes.root}>
      <Typography>Highlights</Typography>
      {data.map((item, index) => (
        <div key={index} className={classes.highlightItem}>
          <div>
            <Icon icon="ic:round-info" className={classes.infoIcon} />
          </div>
          <div className={classes.infoText}>
            <Typography>{item.info}</Typography>
          </div>
          <div className={classes.flexGrow}></div>
          <div>
            <CoreButton
              variant="outlined"
              onClick={() => handleButtonClick(index)}
              size="small"
              color="secondary"
            >
              {item.buttonText}
            </CoreButton>
          </div>
        </div>
      ))}
    </div>
  )
}

export default withStyles(styles)(Highlights)
